import ReactApexChart from "react-apexcharts";
import React, { useEffect, useState, memo } from "react";
import { useLineGraphContext } from "../../Context/lineGraphContext";
import dayjs from "dayjs";

function LineGraphComp({ height, position, showFullDate, notShowYaxis,
  dashArray = [2, 0], colors = ["#3347E6", "#EF5DA8"], decimals = 2, dateFormat = "YYYY/MM/DD", sortTooltip = false }) {

  const sortedTooltip = ({ series, dataPointIndex, w }) => {
    const label = w.globals.labels[dataPointIndex];
    const title = showFullDate ? dayjs(label).format(dateFormat) : label;

    const rows = series
      .map((values, i) => ({ name: w.globals.seriesNames[i], color: w.globals.colors[i], value: values[dataPointIndex] }))
      .filter((row) => row.value !== null && row.value !== undefined)
      .sort((a, b) => b.value - a.value)
      .map((row) =>
        `<div style="display:flex;align-items:center;gap:8px;padding:2px 10px;">` +
          `<span style="width:12px;height:12px;border-radius:50%;background:${row.color};"></span>` +
          `<span>${row.name}: <b>${row.value}</b></span>` +
        `</div>`)
      .join("");

    return `<div class="apexcharts-tooltip-title">${title}</div><div style="padding:4px 0;">${rows}</div>`;
  };

  let LineGraphContext = useLineGraphContext();
  
  const seriesFunc = (param) => {
    
    let dataArray = []
    LineGraphContext.propData.Values?.forEach(x => {
        dataArray.push({
            name: x.Label,
            data: x.Values,
        })
    })
    
    return dataArray;
  };

  const optFunc = (param) => {
    let options = {
      colors: colors,
      grid: {
        row: {
          opacity: 0.5,
        },
        column: {
          opacity: 0.5,
        },
      },
      legend: {
        position: "top",
      },
      yaxis: {
        show: !notShowYaxis,
        min: 0,
        decimalsInFloat: decimals,
        forceNiceScale: true,
        labels: {
          style: {
            color: "#008FFB",
          },
        },
      },

      chart: {
        toolbar: {
          show: false,
        },
      },
      markers: {
        size: 3,
        hover: {
          sizeOffset: 6,
        },
      },
      stroke: {
        curve: "smooth",
        width: [2, 2],
        dashArray: dashArray,
      },
      xaxis: {
        type: "string",
        categories: ["01/06", "02/06", "03/06", "04/06"],
        labels: {
            formatter: function (val) {
              return showFullDate ? dayjs(val).format(dateFormat) : val;
            },
          },
      },
      tooltip: {
        x: {
          format: "dd/MM/yy",
        },
        ...(sortTooltip ? { shared: true, intersect: false, custom: sortedTooltip } : {}),
      },
      grid: {
        padding: {
          left: showFullDate ? 25 : 10,
        },
        xaxis: {
          lines: {
            show: true,
          },
        },
        yaxis: {
          lines: {
            show: true,
          },
        },
      },
    };

    let def = () => options;
    if (LineGraphContext.propData == undefined || LineGraphContext.propData == null) {
      return def();
    }
    if (Array.isArray(LineGraphContext.propData.ValuesDate) && LineGraphContext.propData.ValuesDate.length > 0) {
      let opt_dat = [];

      for (const item of LineGraphContext.propData.ValuesDate) {
        opt_dat.push(
          showFullDate ? item :
          item.substr(
            item.indexOf("-") + 1,
            item.indexOf("T") - 5
          ).replace("-", "/")
        );
      }

      options.xaxis.categories = opt_dat;
      return def();
    }
    return def();
  };

  if (window.matchMedia("(max-width: 600px)").matches && showFullDate) // work only after page refresh
    height = height / 2;

  return (
    <div
      style={{
        textAlign: "center",
        paddingBottom: position,
      }}
    >
      <ReactApexChart
        options={optFunc()}
        series={seriesFunc()}
        type="line"
        height={height}
      />
    </div>
  );
}

export default LineGraphComp;
